// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { paymentMethodStyles } from "@bg/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPaymentMethod";
import { fontConfig } from "@bg/XDL/PreStyle/typography";
import xScreen from "@bg/XDL/Utilities/xScreen";
import { css } from "styled-components";

paymentMethodStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: ${fontConfig.spacing.smallHeading};
    `,
};

paymentMethodStyles.title = {
    variant: "h2",
    css: css`
        margin-bottom: 0;
    `,
};

paymentMethodStyles.paymentMethodText = {
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 8px;
    `,
};

paymentMethodStyles.innerContainer = {
    css: css`
        display: grid;
        grid-template-columns: 1fr 1fr;
        justify-content: space-between;
        gap: 24px 60px;
        width: 100%;
        ${xScreen("lte", "md")} {
            grid-template-columns: 1fr;
        }
    `,
};

paymentMethodStyles.leftSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

paymentMethodStyles.rightSection = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;
    `,
};

paymentMethodStyles.billingAddress = {
    lineHeight: fontConfig.lineHeight.regular,
    weight: fontConfig.weight.bold,
    css: css`
        margin-bottom: 0;
    `,
};

paymentMethodStyles.headingAndTextStyles = {
    wrapper: {
        css: css`
            gap: 4px;
            flex-direction: row;
        `,
    },
    heading: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        transform: "capitalize",
        weight: fontConfig.weight.bold,
        css: css`
            white-space: nowrap;
        `,
    },
    text: {
        size: fontConfig.fontSize.regular,
        lineHeight: fontConfig.lineHeight.regular,
        css: css`
            white-space: nowrap;
        `,
    },
};

paymentMethodStyles.paymentMethodText = {
    lineHeight: fontConfig.lineHeight.regular,
};
